import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PopoverService {
	#popovers = signal<
		{
			id: string;
			message: string;
			position: { x: number; y: number };
		}[]
	>([]);

	activePopovers = this.#popovers.asReadonly();

	show(config: { message: string; origin: HTMLElement; duration?: number }) {
		const id = crypto.randomUUID();
		const position = this.#calculatePosition(config.origin);

		this.#popovers.update((old) => [
			...old,
			{ id, message: config.message, position },
		]);

		setTimeout(() => this.#dismiss(id), config.duration ?? 2000);
	}

	dismissAll() {
		this.activePopovers().forEach((t) => this.#dismiss(t.id));
	}

	#dismiss(id: string) {
		this.#popovers.update((old) => old.filter((t) => t.id !== id));
	}

	#calculatePosition(element: HTMLElement) {
		const rect = element.getBoundingClientRect();
		return {
			x: rect.left + rect.width / 2,
			y: rect.top,
		};
	}
}
